import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useIsGitSyncedTeamsPaginated = () => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isGitSyncedTeamsPaginated = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isGitSyncedTeamsPaginated
  });

  return !!isGitSyncedTeamsPaginated;
};

export default useIsGitSyncedTeamsPaginated;
